(ns frontend.view.grid.sales-opportunities-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce sales-opportunities (r/cursor app-db/views [:sales-opportunities-grid]))
(defonce modal-state (r/cursor sales-opportunities [:modals]))
(defonce grid-entities (r/cursor sales-opportunities [:grid-entities]))
(defonce view-settings (r/cursor sales-opportunities [:view-settings]))
(defonce sales-opportunity-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))
(defonce won-modal* (r/cursor modal-state [:won-modal]))

;;kanban related definitions
(defonce kanban (r/cursor sales-opportunities [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor sales-opportunities [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor sales-opportunities [:schema]))
